module.exports = __webpack_public_path__ + "static/img/jiang3.e7ef8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiang3.png
// module id = I5w+
// module chunks = 1